import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { KeycloakGuard } from 'app/modules/auth/login/keycloak.guard';
import { NgxLoadingModule } from 'ngx-loading';
import { AccordionModule } from 'primeng-lts/accordion';
import { PurchaseOrderService } from '../globals-services/purchase-order.service';
import { AddPurchaseOrderComponent } from './add-purchase-order/add-purchase-order.component';
import { ConfirmClosePoDialogComponent } from './confirm-close-po-dialog/confirm-close-po-dialog.component';
import { PurchaseOrderComponent } from './purchase-order.component';
import { ShowPartialDeliveriesComponent } from './show-partial-deliveries/show-partial-deliveries.component';
import { UpdatePoItemDeliveryDialogComponent } from './update-po-item-delivery-dialog/update-po-item-delivery-dialog.component';
import { ViewDetailPurchaseOrderComponent } from './view-detail-purchase-order/view-detail-purchase-order.component';
const routes: Routes = [

  { path: '', canActivate: [KeycloakGuard], component: PurchaseOrderComponent },
  { path: 'add',canActivate: [KeycloakGuard], component: AddPurchaseOrderComponent },
  { path: 'update/:id', canActivate: [KeycloakGuard], component: AddPurchaseOrderComponent },
  { path: 'view/:id', canActivate: [KeycloakGuard], component: ViewDetailPurchaseOrderComponent },

];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatRadioModule,
    AccordionModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    MatTooltipModule,
    MatPaginatorModule

  ],

  declarations: [
    PurchaseOrderComponent,
    AddPurchaseOrderComponent,
    ConfirmClosePoDialogComponent,
    ShowPartialDeliveriesComponent,
    UpdatePoItemDeliveryDialogComponent,
    ViewDetailPurchaseOrderComponent
  ],
  entryComponents: [ConfirmClosePoDialogComponent,
    ShowPartialDeliveriesComponent, UpdatePoItemDeliveryDialogComponent],

  providers: [
    PurchaseOrderService
  ]
})
export class PurchaseOrderModule { }
